import { render, staticRenderFns } from "./woXingConfirm.vue?vue&type=template&id=3a2c729e&scoped=true&"
import script from "./woXingConfirm.vue?vue&type=script&lang=js&"
export * from "./woXingConfirm.vue?vue&type=script&lang=js&"
import style0 from "./woXingConfirm.vue?vue&type=style&index=0&id=3a2c729e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2c729e",
  null
  
)

export default component.exports